import { Avatar, AvatarProps } from "@mantine/core"
import { usePersonProfilePictureUrlWithAttachmentIdQuery } from "../../../attachment-api/person-attachment-api"

interface Props extends Omit<AvatarProps, "src" | "size"> {
  personId: number
  size?: number
  onClick?: () => void
}
export function PersonProfilePictureAvatar({
  personId,
  size,
  ...props
}: Props) {
  const profilePicture = usePersonProfilePictureUrlWithAttachmentIdQuery(
    personId,
    size ? size * 4 : 320
  )

  return (
    <Avatar
      color="initials"
      size={size}
      src={profilePicture ?? undefined}
      {...props}
    />
  )
}
